import { useTranslation } from "react-i18next";

type PropsType = {
  headerGroups: any;
  fillPage: boolean;
};
const TableHeader: React.FC<PropsType> = ({ fillPage, headerGroups }) => {
  const { i18n } = useTranslation();

  return (
    <thead
      style={
        fillPage
          ? {
              position: "sticky",
              zIndex: 100,
              top: 0,
              backgroundColor: "white",
            }
          : {}
      }
      className="w-full border-b rounded-md select-none "
    >
      {headerGroups.map((headerGroup: any, index: number) => (
        <tr key={index} {...headerGroup.getHeaderGroupProps()}>
          {headerGroup.headers.map((column: any, index2: number) => {
            return (
              <th
                className="px-4"
                key={index2}
                {...column.getHeaderProps(column.getSortByToggleProps())}
              >
                <div
                  className={`flex items-center text-sm text-[#969696] font-normal text-center ${
                    i18n.language === "en" ? "pr-4" : "pl-4"
                  }   py-4`}
                >
                  <div className="truncate " title={column.render("Header")}>
                    {column.render("Header")}
                  </div>
                  {/*  {column.canSort &&
                    (column.isSorted ? (
                      column.isSortedDesc ? (
                        <TiArrowSortedDown className="cursor-pointer" />
                      ) : (
                        <TiArrowSortedUp />
                      )
                    ) : (
                      <TiArrowSortedDown className="text-gray-400 cursor-pointer" />
                    ))} */}
                </div>
              </th>
            );
          })}
        </tr>
      ))}
    </thead>
  );
};
export default TableHeader;
